import { memo } from 'react';
import { cn } from '../../lib/utils';
import { getAgentHarnessIconConfig, getModelIconConfig } from '../../lib/model-icons';

interface AgentAvatarProps {
  /**
   * Agent-type id of the harness running the agent (`claude-code`, `codex`,
   * `opencode`, `cursor`). When recognized, its brand wins over the model's:
   * an OpenCode agent on a Fireworks model shows the OpenCode glyph.
   */
  agentType?: string | null;
  model?: string | null;
  size?: 'sm' | 'md';
  className?: string;
}

const containerClasses = {
  sm: 'h-7 w-7',
  md: 'h-8 w-8',
} as const;

const iconClasses = {
  sm: 'h-3.5 w-3.5',
  md: 'h-4 w-4',
} as const;

export const AgentAvatar = memo(function AgentAvatar({
  agentType,
  model,
  size = 'sm',
  className,
}: AgentAvatarProps) {
  const {
    icon: Icon,
    color,
    bgColor,
    isBrandSvg,
  } = getAgentHarnessIconConfig(agentType) ?? getModelIconConfig(model);

  return (
    <span
      data-testid="agent-avatar"
      className={cn(
        // Border, not ring, for the same reason as `UserAvatar`: a ring paints
        // outside the border box and is clipped by the paint containment of a
        // transcript row's `content-visibility: auto`.
        'flex items-center justify-center rounded-full border border-border',
        containerClasses[size],
        bgColor,
        className,
      )}
    >
      <Icon className={cn(iconClasses[size], !isBrandSvg && color)} />
    </span>
  );
});
